var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',[(_vm.isHasMenu)?_c('el-aside',{attrs:{"width":"250px"}},[_c('LeftMenu',{attrs:{"menus":_vm.menus}})],1):_vm._e(),_c('el-main',[_c('div',{staticClass:"navigation"},[_c('MenuNavigation')],1),_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }